var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3C97AA",
  fillRule: "evenodd",
  d: "M9.166 9.167v-5h1.667v5h5v1.666h-5v5H9.166v-5h-5V9.167h5Z",
  clipRule: "evenodd"
})));
export { SvgAdd as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjE2NjUgOS4xNjY2M1Y0LjE2NjYzSDEwLjgzMzJWOS4xNjY2M0gxNS44MzMyVjEwLjgzMzNIMTAuODMzMlYxNS44MzMzSDkuMTY2NVYxMC44MzMzSDQuMTY2NVY5LjE2NjYzSDkuMTY2NVoiIGZpbGw9IiMzQzk3QUEiLz4KPC9zdmc+Cg==";